<div class="success-dialog-wrapper flex justify-center items-center flex-col">
  <i class="fal fa-times close-icon" (click)="close()"></i>
  <i class="fal fa-check-circle"></i>
  <p>Se han solicitado los cambios, puedes revisar el estado de estas solicitudes en <span class="link"
      (click)="goToConfig()">configuraciones</span></p>
  <app-accent-button class="h-13  text-xl" text="Hecho" [selected]="true" (click)="close()"></app-accent-button>
</div>